import React from "react";
import logo from "./../../../../assets/images/ikizmet-md.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-inner">
        <img src={logo} className="logo ikizmet"  alt="logo"/>
        <div className="footer-info">
          <p>Copyright &copy; 2004-{currentYear} ClubReady, LLC. All Rights Reserved</p>
          <p>
            <a href="https://login.ikizmet.com/tos.html" target="_blank" rel="noopener noreferrer">
              TOS
            </a>
            &nbsp;/&nbsp;
            <a
              href="https://login.ikizmet.com/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
